
export function initScrollActivate(scrollActivateItems = document.querySelectorAll('.scrollActivate')){
    if (scrollActivateItems.length) {
        document.addEventListener("scroll", function () {
            for (const scrollActivate of scrollActivateItems) {
                const boundingClientRect = scrollActivate.getBoundingClientRect();
                if (boundingClientRect) {
                    let startPosition = boundingClientRect.y + boundingClientRect.height / 2;
                    const windowOuterHeight = window.outerHeight;
                    if (boundingClientRect.height > windowOuterHeight) {
                        startPosition = boundingClientRect.y;
                    }
                    if ((startPosition) < windowOuterHeight / 3 * 2) {
                        scrollActivate.classList.add('is-active');
                    }
                }
            }
        });
    }
}